import { AdBreak } from 'common/api/v1/types'
import { format } from 'date-fns'
import { DATE_FORMAT_LONG, formatMs } from 'common/api/v1/helpers'

export const getEndTime = (adBreak: AdBreak): { timestamp?: Date; estimated: boolean } => {
  if (adBreak.endedAt) {
    return { timestamp: new Date(adBreak.endedAt), estimated: false }
  }

  if (adBreak.endsAt) {
    return { timestamp: new Date(adBreak.endsAt), estimated: true }
  }

  if (adBreak.playlist?.ads) {
    const totalMs = adBreak.playlist.ads.reduce((acc, ad) => acc + ad.durationMs, 0)
    return { timestamp: new Date(adBreak.startsAt.getTime() + totalMs), estimated: true }
  }

  return { timestamp: undefined, estimated: false }
}

export const getDuration = (adBreak: AdBreak): { duration?: number; estimated: boolean } => {
  const { timestamp, estimated } = getEndTime(adBreak)
  if (!timestamp) {
    return { duration: undefined, estimated: false }
  }

  return { duration: timestamp.getTime() - adBreak.startsAt.getTime(), estimated }
}

export const getStartTimeFormatted = ({ startsAt }: AdBreak): string => {
  const now = new Date()

  const diffMs = now.getTime() - startsAt.getTime()
  const diffMinutes = Math.abs(diffMs) / (1000 * 60)
  const isFuture = diffMs < 0

  if (diffMinutes < 1) {
    return isFuture ? '< 1 minute' : '< 1 minute ago'
  }

  if (diffMinutes < 60) {
    const minutes = Math.floor(diffMinutes)
    return isFuture
      ? `${minutes} minute${minutes !== 1 ? 's' : ''}`
      : `${minutes} minute${minutes !== 1 ? 's' : ''} ago`
  }

  return format(startsAt, DATE_FORMAT_LONG)
}

export const getEndTimeFormatted = (adBreak: AdBreak): string => {
  const { timestamp } = getEndTime(adBreak)
  if (!timestamp) {
    return '-'
  }

  const now = new Date()

  const diffMs = now.getTime() - timestamp.getTime()
  const diffMinutes = Math.abs(diffMs) / (1000 * 60)
  const isFuture = diffMs < 0

  if (diffMinutes < 1) {
    return isFuture ? '< 1 minute' : '< 1 minute ago'
  }

  if (diffMinutes < 60) {
    const minutes = Math.floor(diffMinutes)
    return isFuture
      ? `${minutes} minute${minutes !== 1 ? 's' : ''}`
      : `${minutes} minute${minutes !== 1 ? 's' : ''} ago`
  }

  return format(timestamp, DATE_FORMAT_LONG)
}

export const getDurationFormatted = (adBreak: AdBreak): string => {
  const { duration, estimated } = getDuration(adBreak)
  if (duration === undefined) {
    return '-'
  }

  return `${formatMs(duration)}${estimated ? ' (estimated)' : ''}`
}
